import type { paths } from "@/autogen/internal-openapi";
import { useAccountStore } from "@/store/stores/account";

import { createClient } from "../openapi";

const internalApi = createClient<paths>({
  // See base.ts for why this is
  base: !import.meta.env.VITEST
    ? "/api/emails/api"
    : "http://localhost:80/api/emails/api",
  middlewares: [
    async (request, next) => {
      const { newsletter } = useAccountStore();
      if (newsletter == null) {
        return next(request);
      }

      request.headers.set("authorization", `Token ${newsletter.api_key}`);
      return next(request);
    },
  ],
});

export default internalApi;
